import React, { useEffect } from 'react'
import { Skeleton, Grid } from '@mui/material'
import { useParams  } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { saveRecentArtist } from '../../actions/mainSlice'
import ArtistSideMenu from './components/board/ArtistSideMenu'
import { useGetArtistTracksQuery } from '../../api/artistApiSlice'
import ArtistSideMenuMobile from './components/board/ArtistSideMenuMobile'
import ArtistTimeline from './components/ArtistTimeline'

const ArtistBoard = () => {
    let { id } = useParams()
    const dispatch = useDispatch()

    const {
        data: tracks
        
    } = useGetArtistTracksQuery({id})

    useEffect(() => {
        dispatch(saveRecentArtist(id))
    }, [dispatch, id])


    return (
        <Grid container spacing={2} sx={{height: '100%'}} >
            <Grid size={{ lg: 4, md:6, xs: 0}} sx={{display: {xs:'none', md:'flex',lg:'flex'}, height: {xs:'0%', md:'100%',lg:'100%'}}}><ArtistSideMenu /></Grid>
            <Grid size={{ lg: 0, md:0, xs: 12}} sx={{display: {xs:'flex', md:'none',lg:'none'}, height: {xs:'25%', md:'100%',lg:'100%'}}}><ArtistSideMenuMobile /></Grid>
            <Grid size={{ lg: 8, md:6, xs: 12}} sx={{height: {xs:'75%', md:'100%',lg:'100%'}}}>
                {
                    tracks && tracks.length > 0
                    ? <ArtistTimeline tracks={tracks} />
                    : <Skeleton /> 
                }
            </Grid>
        </Grid>
    )
}

export default ArtistBoard